module.exports = __webpack_public_path__ + "img/flomdatabase.52db7499.jpg";